import { atom } from 'jotai';

import { ServiceTypeFormState } from '~/modules/transportation/types';

const initialState: ServiceTypeFormState = {
  name: '',
  description: '',
  isActive: true,
  isSystemDefault: false,
  taskDefinitions: [],
};

export const $serviceTypeForm = atom<ServiceTypeFormState>(initialState);

export const $resetServiceTypeForm = atom(null, (get, set) => {
  set($serviceTypeForm, initialState);
});

export const $updateServiceTypeForm = atom(
  null,
  (get, set, update: Partial<ServiceTypeFormState>) => {
    const currentState = get($serviceTypeForm);
    set($serviceTypeForm, { ...currentState, ...update });
  },
);
